import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';
import { useUserStore } from '../store/userStore';
import { moveSubscription, ownSubscription } from './usePushApi';

// Хуки для аутентификации
export const useRegister = () => {
  return useMutation({
    mutationFn: async ({ email, name }: { email: string; name: string }) => {
      return await api('/auth/register', {
        method: 'POST',
        body: { email, name },
      });
    },
  });
};

export const useLogin = () => {
  return useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      return await api('/auth/login', {
        method: 'POST',
        body: { email },
      });
    },
  });
};

export const useVerifyCode = () => {
  return useMutation({
    mutationFn: async ({ email, code }: { email: string; code: string }) => {
      return await api('/auth/verify', {
        method: 'POST',
        body: { email, code },
      });
    },
  });
};

export const useResendCode = () => {
  return useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      return await api('/auth/resend-code', {
        method: 'POST',
        body: { email },
      });
    },
  });
};

/** Компания в выборе после кода и в «Сменить компанию». */
export interface CompanyChoice {
  id: string;
  name: string;
  logoUrl: string | null;
  isCurrent?: boolean;
}

/** Почта в нескольких компаниях: `verify` отдаёт их и билет вместо токена. */
export const useChooseCompany = () =>
  useMutation({
    mutationFn: ({ ticket, tenantId }: { ticket: string; tenantId: string }) =>
      api('/auth/choose', { method: 'POST', body: { ticket, tenantId } }),
  });

/** Компании той же почты; больше одной — в меню «Сменить компанию». */
export const useMyCompanies = () => {
  const userId = useUserStore((s) => s.user?._id);
  return useQuery({
    queryKey: ['auth', 'companies', userId],
    queryFn: (): Promise<CompanyChoice[]> => api('/auth/companies'),
    enabled: !!userId,
    staleTime: 5 * 60_000,
  });
};

/**
 * Перейти в другую компанию без кода. Пуш-подписка переезжает к новой учётке, если была у
 * прежней. Дальше — полная загрузка: брендинг, права и кеш — уже новой компании.
 */
export async function switchCompany(tenantId: string) {
  const own = await ownSubscription().catch(() => null);
  const data = await api('/auth/switch', { method: 'POST', body: { tenantId } });
  useUserStore.getState().setToken(data.token);
  if (own) await moveSubscription(own).catch((e) => console.warn('[push] move failed', e));
  window.location.assign('/dashboard');
}
